<app-menu currentMenu="services"></app-menu>
<div class="page page-legal">
  <div class="container" *ngIf="data">
    <h1>{{data.title}}</h1>
    <div [innerHTML]="data.content | marked"></div>
  </div>
  <app-loading *ngIf="!data"></app-loading>
</div>
<app-footer></app-footer>
